export const UNAVAILABLE_LABEL = 'não disponível';
